import { createFileRoute } from '@tanstack/react-router'

import { ContractTemplatesProductPage } from '#/modules/intake/contract-templates-product-page'

export const Route = createFileRoute('/_shell/contract-templates/')({
  component: ContractTemplatesProductPage,
})
